import { render, staticRenderFns } from "./pc-specs-section.vue?vue&type=template&id=4b759371&"
import script from "./pc-specs-section.vue?vue&type=script&lang=js&"
export * from "./pc-specs-section.vue?vue&type=script&lang=js&"
import style0 from "./pc-specs-section.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports